import styled, { css } from 'styled-components'
import {
  RELEASE_INFORMATION_LAYOUT_QUERIES,
  releaseInfoMobileDownQuery,
  releaseInfoReactGridLargeUpQuery,
  releaseInfoTabletUpQuery
} from '../../responsiveQueries'

const fluidAttachmentGrid = '48px minmax(0, 1fr) 32px'

export const AttachmentContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ $responsiveBreakpointsV2 }) =>
    $responsiveBreakpointsV2 ? fluidAttachmentGrid : '2fr 10fr 1fr'};
  align-items: center;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.neutralW20};
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ $responsiveBreakpointsV2 }) =>
    !$responsiveBreakpointsV2 &&
    css`
      @media ${releaseInfoTabletUpQuery} {
        grid-template-columns: 3fr 14fr 1fr;
      }

      @media ${releaseInfoReactGridLargeUpQuery} {
        grid-template-columns: 2fr 14fr 1fr;
      }

      @media ${RELEASE_INFORMATION_LAYOUT_QUERIES.attachmentUltraWideUp} {
        grid-template-columns: 1fr 14fr 1fr;
      }
    `}
`
export const AttachmentTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const AttachmentSize = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const TitleWrapper = styled.div`
  min-width: ${({ $responsiveBreakpointsV2 }) =>
    $responsiveBreakpointsV2 ? 0 : 'auto'};

  @media ${releaseInfoMobileDownQuery} {
    width: ${({ $responsiveBreakpointsV2 }) =>
      $responsiveBreakpointsV2 ? 'min(200px, 100%)' : '200px'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  padding: 11.294px;
  align-items: flex-start;
  border-radius: 7.059px;
  background: ${({ theme }) => theme.colors.player30};
`

export const ActionWrapper = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  width: 32px;
  height: 32px;
  padding: 7px;
  border: 0;
  border-radius: 50px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition:
    background-color 120ms ease,
    color 120ms ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW30};
  }

  &:focus-visible {
    outline: none;
    background-color: ${({ theme }) => theme.colors.neutralW30};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.neutralW70};
  }
`
